import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { DashboardNavItem } from '../components';
import PublishedDashboardTemplates from './PublishedDashboardTemplates';
import {
  IDashboardFolderFieldsFragment,
  IDashboardFolderQuery,
  IDashboardFolderQueryVariables,
} from '../../../../utils/apollo/graphqlSchema';
import { dashboardFolderQuery } from '../../../../utils/apollo/dashboards';
import CreateDashboardFolder from './CreateDashboardFolder';
import { SUB_FOLDERS_MAX_DEPTH } from '../../../../config/constants';
import { useAppDispatch } from '../../../../redux/hooks';
import { populatePublishedFolder } from '../../../../redux/slices/dashboards/dashboardInstance';
import PublishedDashboardSubFolders from './PublishedDashboardSubFolders';

interface IProps {
  publishedFolder: IDashboardFolderFieldsFragment;
  createFolderMode?: boolean;
  setCreateFolderMode?: (createMode: boolean) => void;
}

const PublishedDashboards = ({
  publishedFolder,
  createFolderMode,
  setCreateFolderMode,
}: IProps) => {
  const dispatch = useAppDispatch();

  const [mouseOverId, setMouseOverId] = useState<string | null>(null);
  const [openedMenuId, setOpenedMenuId] = useState<string | null>(null);

  const { path, subFolders, templates } = publishedFolder;

  const handleLoadFolder = ({ dashboardFolder }: IDashboardFolderQuery) => {
    dispatch(populatePublishedFolder({ publishedFolder: dashboardFolder }));
  };

  const [loadFolder] = useLazyQuery<
    IDashboardFolderQuery,
    IDashboardFolderQueryVariables
  >(dashboardFolderQuery, {
    onCompleted: handleLoadFolder,
  });

  const pathNotEmpty = path && path?.length > 0;
  const parentFolderId = pathNotEmpty ? path[path.length - 1].id : null;

  const handleChangeFolder = (newFolderId: string | null) => {
    loadFolder({
      variables: {
        id: newFolderId,
      },
    });
  };

  const handleGoToPreviousFolder = () => {
    handleChangeFolder(path.length > 0 ? path[path.length - 1].parentId : null);
  };

  return (
    <>
      {pathNotEmpty && (
        <DashboardNavItem
          iconName="arrow-left-bold"
          title={path[path.length - 1].name}
          onClick={handleGoToPreviousFolder}
        />
      )}
      {createFolderMode &&
        (!pathNotEmpty || path.length < SUB_FOLDERS_MAX_DEPTH) && (
          <CreateDashboardFolder
            parentFolderId={parentFolderId}
            setCreateFolderMode={setCreateFolderMode}
          />
        )}
      {subFolders.length > 0 && (
        <PublishedDashboardSubFolders
          subFolders={subFolders}
          onChangeFolder={handleChangeFolder}
          mouseOverId={mouseOverId}
          setMouseOverId={setMouseOverId}
          openedMenuId={openedMenuId}
          setOpenedMenuId={setOpenedMenuId}
        />
      )}
      {templates.length > 0 && (
        <PublishedDashboardTemplates
          templates={templates}
          mouseOverId={mouseOverId}
          setMouseOverId={setMouseOverId}
          openedMenuId={openedMenuId}
          setOpenedMenuId={setOpenedMenuId}
        />
      )}
    </>
  );
};

export default PublishedDashboards;
